import React from 'react';
import { Search, RefreshCw, Eye, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';

export default function JobsTab({
  jobs, searchQuery, setSearchQuery, jobStatusFilter, setJobStatusFilter,
  fetchJobs, formatDate, actionLoading, navigate, handleDeleteJob,
  jobsPage, jobsTotalPages, setJobsPage
}) {
  return (
    <div className="space-y-4" data-testid="jobs-tab">
      <div className="bg-white rounded-xl shadow-md p-4">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              placeholder="Search jobs..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-9"
              data-testid="search-jobs"
            />
          </div>
          <select
            value={jobStatusFilter}
            onChange={(e) => setJobStatusFilter(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md"
            data-testid="filter-job-status"
          >
            <option value="all">All Status</option>
            <option value="open">Open</option>
            <option value="closed">Closed</option>
            <option value="filled">Filled</option>
          </select>
          <Button onClick={fetchJobs} variant="outline">
            <RefreshCw className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Job</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contractor</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Posted</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {jobs.map((job) => (
              <tr key={job._id} className="hover:bg-gray-50" data-testid={`job-row-${job._id}`}>
                <td className="px-6 py-4">
                  <div>
                    <p className="font-medium text-gray-900">{job.title}</p>
                    <p className="text-sm text-gray-500">{job.location}</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-gray-900">{job.contractor?.name || 'N/A'}</p>
                    <p className="text-sm text-gray-500">{job.contractor?.email}</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <Badge className={
                    job.status === 'open' ? 'bg-green-100 text-green-700' :
                    job.status === 'filled' ? 'bg-blue-100 text-blue-700' :
                    'bg-gray-100 text-gray-700'
                  }>{job.status}</Badge>
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">{formatDate(job.created_at)}</td>
                <td className="px-6 py-4">
                  <div className="flex justify-end space-x-2">
                    <Button size="sm" variant="outline" onClick={() => navigate(`/job/${job._id}`)}>
                      <Eye className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="outline" onClick={() => handleDeleteJob(job._id)} disabled={actionLoading === job._id} className="text-red-600 hover:bg-red-50">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <p className="text-sm text-gray-500">Page {jobsPage} of {jobsTotalPages}</p>
          <div className="flex space-x-2">
            <Button size="sm" variant="outline" disabled={jobsPage === 1} onClick={() => setJobsPage(p => p - 1)}>
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <Button size="sm" variant="outline" disabled={jobsPage >= jobsTotalPages} onClick={() => setJobsPage(p => p + 1)}>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
